import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Check",
  "use": "Check-usage",
  "viewBox": "0 0 11 9",
  "content": "<symbol viewBox=\"0 0 11 9\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Check\"><path d=\"M9.9 0L3.667 6.234 1.1 3.667 0 4.767l3.667 3.666L11 1.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/Check.svg
// module id = 272
// module chunks = 0